






























































































































































import Page from '@/Page.vue';
import { Component } from 'vue-property-decorator'
import {PartyBasicModel, PredicateDefinition, ReportPrintQueryModel, ReportPrintTypeEnum} from "@/libs/Api";
import moment from "moment/moment";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import {CrudQueryPredicate} from "@/libs/core/+state/models/crud-query-predicate";

@Component({})
export default class ReportClients extends Page {

	fromDate: string | null = null;
	filterDistrict: string | null = null;
	filterTown: string | null = null;
	filterSex: string | null = null;
	filterBenefitClaim: boolean | null = null;
	filterCareAllowence: string | null = null;
	filterWorkTaskRuleFromDate: string | null = null;
	filterAgeFrom: number | null = null;
	filterAgeTo: number | null = null;
	report: any = null;
    
    loading = false;
    printing = false;
    
    getPredicates(): CrudQueryPredicate[] {

		let filters: CrudQueryPredicate[] = [];

		if (this.filterDistrict) {

			filters.push({ field: "districtId", op: "eq", comparand: this.filterDistrict });

			if (this.filterTown)
				filters.push({ field: "townId", op: "eq", comparand: this.filterTown });

		}

		if (this.filterSex)
			filters.push({ field: "sex", op: "eq", comparand: this.filterSex });

		if (this.filterBenefitClaim != null)
			filters.push({ field: "benefitClaim", op: "eq", comparand: this.filterBenefitClaim });

		if (this.filterCareAllowence != null)
			filters.push({ field: "careAllowenceId", op: "eq", comparand: this.filterCareAllowence });

		if (this.filterAgeFrom)
			filters.push({ field: "birthDate", op: "lte", comparand: moment().add(this.filterAgeFrom * -1, 'years').endOf('day').format("YYYY-MM-DDTHH:mm:ss") });

		if (this.filterAgeTo)
			filters.push({ field: "birthDate", op: "gte", comparand: moment().add(this.filterAgeTo * -1, 'years').endOf('day').format("YYYY-MM-DDTHH:mm:ss") });

		if (this.filterWorkTaskRuleFromDate)
			filters.push({ field: "workTaskRules.startDate", op: "gte", comparand: this.filterWorkTaskRuleFromDate });

		return filters;

	}
    
    loadReport() {
        const query = {
            predicates: this.getPredicates() as PredicateDefinition[],
            orderby: [
                { field: "fromDate", index: 1, order: "desc"}
            ],
            fileName: "Přehled klientů",
            printType: ReportPrintTypeEnum.Clients,
            fromDate: moment(this.fromDate).format("YYYY-MM-DDT00:00:00"),
            toDate: moment(this.fromDate).endOf('month').format("YYYY-MM-DDT23:59:59")
        } as ReportPrintQueryModel;
        this.loading = true;
        ApiService.api.reportBatch(query).then((x: any) => {
            this.loading = false;
            const res = x.data;
            this.report = res.returnValue;
        }).catch(() => {
            this.loading = false;
        });
    }
    
    printReport() {
        this.printing = true;
        const query = {
            predicates: this.getPredicates() as PredicateDefinition[],
            orderby: [
                { field: "fromDate", index: 1, order: "desc"}
            ],
            fileName: "Přehled klientů",
            printType: ReportPrintTypeEnum.Clients,
            fromDate: moment(this.fromDate).format("YYYY-MM-DDT00:00:00"),
            toDate: moment(this.fromDate).endOf('month').format("YYYY-MM-DDT23:59:59")
        } as ReportPrintQueryModel;
        ApiService.api.printReportBatch(query).then((x: any) => {
            this.printing = false;
            const res = x.data;
            const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', res.returnValue.filename!);
            document.body.appendChild(link);
            link.click();
            link.parentNode!.removeChild(link);
        }).catch(() => {
            this.printing = false;
        });
    }
    
    clearReport() {
        this.report = null;
    }

	getAge(item: PartyBasicModel): string {
		if (!item.birthDate) {
			return '';
		}
		return Math.floor(moment().diff(item.birthDate, 'years')).toFixed(0).concat(" let");
	}
    
}
